import { PLANNER_COLORS_TYPE } from "components/controls/select/SelectorPlannerShowH"
import { Activity, TAGS } from "components/planner/types"
import { setType } from "components/planner/utils"
import dayjs from "dayjs"
import { EditCycle } from "stores/cycle/utils/edit"
import querySo from "stores/route/query"
import { URL_PAR } from "stores/route/utils/types"
import { Cycle } from "types/Cycle"
import { Layer } from "types/Layer"
import { Color, DateString } from "types/global"
import { dateToString } from "utils"
import { Colors, hashStringToColor } from "utils/color"
import { dateWithoutTime, diffDay } from "utils/time"


/**
 * da un array CYCLEs restituisce un array di ACTIVITY
 */
export function activitiesFromCycles(
	cycles: Cycle[],
	growUnitId: number,
): Activity[] {

	const colorsType = querySo.getSearchUrl(URL_PAR.PLANNER_COLORS)

	// restituisce tutte le ACTIVITY raggruppate per CYCLE
	const actCycles = cycles
		.filter(cycle => cycle.growUnitId == null || cycle.growUnitId == growUnitId)
		.map(cycle => {

			// definizione del COLOR
			let color = <Color>"#F0F0F0"
			// se deve esser definito in base al CYCLEo in base al CROP
			if (!colorsType || colorsType == PLANNER_COLORS_TYPE.CYCLES) {
				color = cycle.color
			} else {
				const toHash = !!cycle.cropLots ? cycle.cropLots.map(cl => cl.cropId).join("") : cycle.cropCycleId?.toString()
				color = hashStringToColor(toHash, Colors)
			}

			// se c'e' normalizzo la data di raccolta
			const yieldTime = cycle.yieldDate ? dateWithoutTime(cycle.yieldDate) : null

			// restituisco tutte le ACTIVITY presenti in un CYCLE
			const actLayers = cycle.layers?.map(layer => {
				// per le PREVIEW
				if (layer.growUnitId != null && layer.growUnitId != growUnitId) return null

				const startTime = dateWithoutTime(layer.busyFrom)
				let endTime = dateWithoutTime(layer.busyTo)

				// se è stato raccolto allora eventualmente taglia il cycle
				if (yieldTime) {
					if (startTime > yieldTime) return null
					if (endTime > yieldTime) endTime = yieldTime
				}
				const delta = diffDay(endTime, startTime) + 1
				const activity: Activity = {
					//layer,	// mi serve per abbinarlo alla "phase" e al "cycleId"
					tags: {
						[TAGS.CYCLES]: [cycle.cycleUuid],
						[TAGS.CYCLE_PHASE]: layer.phase,
						[TAGS.GROWUNIT_ID]: growUnitId,
						[TAGS.GROWUNIT_PHASE]: layer.phase,
						[TAGS.LAYER_NUMBER]: layer.layerNumber,

						[TAGS.EDIT]: cycle._edit?.type,
						[TAGS.SESSION]: EditCycle.getExtra(cycle, TAGS.SESSION),
					},
					start: startTime,
					length: delta,
					//row,
					color,
				}
				return activity
			}).filter(activity => activity)

			setType(actLayers)
			return actLayers
		})
		.filter(activities => activities && activities.length > 0)

	return actCycles.flat(Infinity) as Activity[]
}

/** 
 * Dato un array di ACTIVITY restituisce un CYCLE (con i suoi "layers" opportunamente settati)
 * */
export function cycleFromActivities(activities: Activity[], yieldDate?: DateString): Cycle {
	const cycleUuid = activities[0]?.tags[TAGS.CYCLES]?.[0]
	if (!cycleUuid) return null

	let minDate: number = null
	let maxDate: number = null
	const layers = activities.map(activity => {
		const dayFrom = dayjs(activity.start)
		const dayTo = dayFrom.add(activity.length - 1, "day")
		if (minDate == null || dayFrom.valueOf() < minDate) minDate = dayFrom.valueOf()
		if (maxDate == null || dayTo.valueOf() > maxDate) maxDate = dayTo.valueOf()
		const layerNumber = activity.tags[TAGS.LAYER_NUMBER]
		return {
			layerNumber,
			busyFrom: dateToString(dayFrom),
			busyTo: dateToString(dayTo),
			phase: activity.tags[TAGS.GROWUNIT_PHASE]
		} as Layer
	})
	const cycle: Cycle = { cycleUuid, layers }
	if (minDate) cycle.seedingDate = dateToString(minDate)
	if (maxDate) cycle.harvestingDate = dateToString(maxDate)
	if (yieldDate) cycle.yieldDate = dateToString(maxDate)
	return cycle
}

